// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"28":"8380e4f3a56b3ca7794a","614":"13c8af462d5a103b4d37","952":"823658f93a707a662c00"}[chunkId] + "/css/" + {"28":"ShiftPage","614":"Approve","952":"TestSettings"}[chunkId] + ".css";
};